
'use strict'

import Validate from './Validate';

class Phone extends Validate {
    
    constructor(){
        super();
        this.error = '{name} no válido';
    }

    validate (value) {
        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        return re.test(value);
    }
}

export default Phone;
